<template>
    <div class="head flex f-between f-align-center">
        <span class="white">
            设备管理系统
        </span>
        <!-- <div class="flex">
            <a class="f12 white" href="javascript:;">管理我的激活码</a>
        </div> -->
         <div class="right flex f-align-center">
            <img :src="logo" alt="">
            <span>{{nick}}</span>
        </div>
    </div>
</template>
<script>
    export default {
          data(){
            return {
                logo:'',
                nick:'',
            }
        },
        created(){
            this.getaccount();
        },    
        methods:{
            getaccount(){
                let that = this;
                that.logo = that.accountutil.getUser().logo;
                that.nick = that.accountutil.getUser().nick;
            },
        }

    }
</script>

<style scoped>
    .head{
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 50px;
        background: #18C3B1;
        z-index: 3;
        padding:0 20px;
    }

    .right img{
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }
</style>


// WEBPACK FOOTER //
// src/pages/topHead.vue